import "./style.scss";

const ScheduleInviteInput = ({
  name,
  changeValue,
  autoComplete,
  label,
  changeLableValue,
  value,
  disabled = false,
  styled,
}) => {
  const numberStyles = {
    ...(styled ? { marginLeft: "5px" } : {}),
  };
  const lableStyles = {
    ...(styled
      ? {
          position: "absolute",
          left: 0,
          bottom: "-5px",
        }
      : {}),
  };

  return (
    <div className="schedule-invite-input" style={numberStyles}>
      <input
        type={"text"}
        name={name}
        autoComplete={autoComplete}
        id={name}
        value={value}
        onChange={(e) => {
          changeValue(e.target.value);
          if (changeLableValue) {
            changeLableValue(name, e.target.value);
          }
        }}
        disabled={disabled}
      />
      <label
        htmlFor={name}
        style={{
          ...(label.includes("!") || label.includes("required")
            ? { color: "red" }
            : { color: "rgb(143, 142, 142)" }),
          ...lableStyles,
        }}
      >
        {label}
      </label>
    </div>
  );
};

export default ScheduleInviteInput;
